import { Toggle } from '@cinesend/ui-kit'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'

const IsLocalizable = ({ field, saveField }) => {
  const isLocalizable = field.is_localizable
  const locked = field.schema.is_locked
  return (
    <DisabledTooltip reason={locked ? DISABLED_REASONS.schemaLocked : null}>
      <Toggle
        pressed={isLocalizable}
        text='Are values localizable?'
        disabled={locked}
        onToggle={() => {
          saveField({ is_localizable: !isLocalizable })
        }}
      />
    </DisabledTooltip>
  )
}

export default IsLocalizable
